import ReduxToolkit, { createSlice } from '@reduxjs/toolkit';

import { kenoInitialState } from '@modules/games/Game/store/keno/kenoInitialState';

const NAME = 'selectedNumbers';

export type ValueType = number[];

const initialState: ValueType =
    kenoInitialState.getInitialState(NAME) || [];

const setAction: ReduxToolkit.CaseReducer<
    ValueType,
    ReduxToolkit.PayloadAction<ValueType>
> = (state, action) => {
    kenoInitialState.setInitialState(NAME, action.payload);

    return action.payload;
};

export const selectedNumbersSlice = createSlice({
    name: NAME,
    initialState,
    reducers: {
        selectedNumbersUpdate: setAction,
    },
});
